import React, { Component } from 'react'
import styles from './Existing.css'
import RewardList from '../Components/RewardList'
import SuccessfulModal from './SuccessfulModal'
import {formatDecimal, rupiah} from 'utils/formatter'
import _sortBy from 'lodash/sortBy'
import ManageAction from './ManageAction'
import moment from 'moment'
import * as mpLoyalty from 'mixpanel/customers/loyalty'
import { Alert } from 'react-bootstrap'
import MenuTitle from 'components/MenuTitle'

class Existing extends Component {

  componentDidMount () {
    mpLoyalty.showManageLoyalty()
  }

  render () {
    let spendingAmount = this.props.earning_rule.amount
    let status
    let durationExtraInfo = ''
    let statusFontColor = '#59bc23'
    if (this.props.status === 'ACTIVE') {
      status = 'Active'
      durationExtraInfo = ', until deactivated manually.'
    } else {
      statusFontColor = '#fbba35'
      status = 'Inactive since ' + moment(this.props.inactive_since).format('DD MMM YYYY')
    }

    return (
      <div>
        <div className='row'>
          <MenuTitle menuTitle='Loyalty Program' />
          <div className={`${styles['action-loyalty-program']} col-md-6`}>
            <div className='pull-right bottom20'>
              <ManageAction
                status={status}
                showEdit={this._showEdit}
                showReset={this._showReset}
                reactivateLoyalty={this._reactivateLoyalty}
                deactivateLoyalty={this._deactivateLoyalty}
              />
            </div>
          </div>
          <div style={{paddingRight: '38px'}} className='col-md-6'>
            <div className='row'>
              <div className='col-md-12'>
                <div className={styles['section-label']}>LOYALTY PROGRAM</div>
                <div className={styles['program-info']}>
                  Status: <span style={{color: statusFontColor}} className={`${styles['program-info-chosen']}`}> {status} </span>
                </div>
                <div className={styles['program-info']}>
                  Created At: <span className={styles['program-info-chosen']}> {moment(this.props.created_at).format('MM/DD/YYYY HH:mm')}</span>
                </div>
                <div className={`${styles['program-info']}`}>
                  Created By: <span className={styles['program-info-chosen']}> {this.props.created_by} </span>
                </div>

                <div className={'bottom30'} />

                <div className={styles['program-info']}>
                  Loyalty Program: <span className={styles['program-info-chosen']}> Rp X = Y Point </span>
                </div>
                <div className={styles['program-info']}>
                  Point Rule: <span className={styles['program-info-chosen']}>
                    For every {rupiah(spendingAmount)} member will get {formatDecimal(this.props.earning_rule.point)} points
                  </span>
                </div>
                <div className={styles['program-info']}>
                  New Member Point: <span className={styles['program-info-chosen']}> {formatDecimal(this.props.new_member_point)} Points </span>
                </div>
              </div>
            </div>
            <div className='row top30'>
              <div style={{paddingRight: '38px'}} className='col-md-12'>
                <div className={styles['section-label']}>DURATION</div>
                <div className={styles['program-info']}>
                  <span className={styles['program-info-chosen']}>No expiry date{durationExtraInfo}</span>
                </div>
              </div>
            </div>
            <div className='row top30'>
              <div style={{paddingRight: '38px'}} className='col-md-12'>
                <div className={styles['section-label']}>Validation Code for Redeem</div>
                <div className={styles['program-info']}>
                  <span className={styles['program-info-chosen']}>
                    {this.props.is_sent_validation_code ? 'Use SMS validation code for every reward redemption'
                      : 'Do not use SMS validation code for reward redemptions'}
                  </span>
                </div>
              </div>
            </div>
            <div className='row top30'>
              <div style={{paddingRight: '38px'}} className='col-md-12'>
                <Alert bsStyle='warning' className={styles['warning-container']}>
                  <div><i className={`fa fa-info-circle fa-2x ${styles['warning-icon']}`} /></div>
                  <div>
                    <span>Loyalty Program can only be used with minimum Moka App v7.0 (android tablet) or v12.8 (iOS)</span>
                  </div>
                </Alert>
              </div>
            </div>
          </div>
          <div style={{paddingLeft: '38px'}} className='col-md-6'>
            <div className={styles['section-label']}>REWARD LIST</div>
            <RewardList rewards={this._toDisplayRewards()} />
          </div>
        </div>
        <SuccessfulModal close={this.props.closeSuccessModal} show={this.props.showSuccessModal} />
      </div>
    )
  }

  _toDisplayRewards = () => {
    let rewards = this.props.rewards.map((reward) => {
      return {
        point: reward.redeem_point,
        discount: reward.discount,
        discountType: reward.discount_type,
        maximumDiscount: reward.max_discount_amount,
        minimumPurchase: reward.min_purchase_amount
      }
    })

    return _sortBy(rewards, ['point'])
  }

  _showEdit = () => {
    this.props.showEdit()
    mpLoyalty.editProgramStart()
  }

  _showReset = () => {
    this.props.showReset()
    mpLoyalty.resetProgramStart()
  }
  _reactivateLoyalty = (data) => {
    this.props.reactivateLoyalty(data)
    mpLoyalty.reactivateLoyalty(this.props)
  }

  _deactivateLoyalty = () => {
    this.props.deactivateLoyalty()
    mpLoyalty.deactivateLoyalty(this.props)
  }
}

export default Existing



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Existing/Existing.js